import React from 'react';
import { Line } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     PointElement,
//     LineElement,
//     Title,
//     Tooltip,
//     Legend
// } from 'chart.js';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
    ScatterController,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
    ScatterController,
);


const GradeChart = ({ data, parentState }) => {
    const dataPoints = Object.keys(data).map(key => ({
        x: Number(key),
        y: Number(data[key]).toFixed(1),
    }));
    let actMP = parentState.maxPunkte[0].slice(-1)[0].value;
    const greenLinePoints = [
        { x: 0, y: '6.0' },
        { x: actMP, y: '1.0' },

    ];

    function getGreenLineY(x) {
        const x1 = greenLinePoints[0].x;
        const y1 = parseFloat(greenLinePoints[0].y);
        const x2 = greenLinePoints[1].x;
        const y2 = parseFloat(greenLinePoints[1].y);
        const m = (y2 - y1) / (x2 - x1);

        return m * (x - x1) + y1;
    }
    const differences = dataPoints.map(point => {
        const greenY = getGreenLineY(point.x);
        const dataY = parseFloat(point.y);
        const diff = dataY - greenY;

        return {
            x: point.x,
            dataY: dataY.toFixed(1),
            greenY: greenY.toFixed(1),
            diff: diff.toFixed(1)
        };
    });

    // console.table(differences);
    // Calculate the mean difference
const totalDiff = differences.reduce((sum, point) => sum + parseFloat(point.diff), 0);
const meanDiff = (totalDiff / differences.length).toFixed(2);

// console.log("Mean Difference:", meanDiff);


    const differenceData = {
        label: "Difference",
        data: differences.map(d => ({ x: d.x, y: d.diff })),
        borderColor: "red",
        fill: false,
        pointRadius: 5,
        pointBackgroundColor: "red",
    };
    



    // const firstPoint = dataPoints[0];
    // const lastPoint = dataPoints[dataPoints.length - 1];
    // const greenLinePoints = [firstPoint, lastPoint];
    // console.log(greenLinePoints);

    const fontFamily = '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif';

    // console.log(data);
    const chartData = {
        datasets: [
            {
                type: 'scatter',
                label: 'Ihr Notenschlüssel',
                data: dataPoints,
                // borderColor: 'rgba(75, 192, 192, 1)',
                borderColor: 'rgba(255, 255, 255, 1)',
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                showLine: false, // Draw line between points to connect them
                spanGaps: false, // Prevent connecting null gaps
                pointRadius: 3, // Control point size
                pointHoverRadius: 6, // Make point larger on hover
                pointBackgroundColor: 'rgba(75, 192, 192, 1)',
                pointHoverBackgroundColor: 'rgba(255, 99, 132, 1)',
                fill: false,
            },
            {
                type: 'line', // Use line type to draw a straight line between start and end points
                label: 'Linearer Notenschlüssel',
                data: greenLinePoints, // Only two points: first and last
                borderColor: 'rgba(0, 255, 0, 1)', // Green color for the line
                borderWidth: 2, // Thicker line to make it more prominent
                pointRadius: 0, // No points to display on this line
                fill: false,
            },
            // differenceData,
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: 'top',
            },
            title: {
                display: false,
                text: 'Linearer Notenschlüssel',
            },
            tooltip: {
                callbacks: {
                    // Customize the tooltip label
                    label: function (context) {
                        const xValue = context.parsed.x;
                        const yValue = context.parsed.y;
                        return `Punkte: ${xValue}, Note: ${yValue}`;
                    },
                    // title: function (context) {
                    //     return `Linearer Notenschlüssel YYY more details?`;
                    // }
                },
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                titleFont: {
                    family: fontFamily,
                    size: 14,
                    weight: 'bold',
                },
                bodyFont: {
                    family: fontFamily,
                    size: 12,
                },
                borderColor: 'rgba(255, 255, 255, 0.7)',
                borderWidth: 1,
                caretSize: 5,
                cornerRadius: 4,
            },
        },
        scales: {
            x: {
                type: 'linear',
                title: {
                    display: true,
                    text: 'Punkte',
                },
                ticks: {
                    stepSize: 5,
                    family: fontFamily,
                    padding: 5,
                },
                grace: '5%',
                beginAtZero: true,
            },
            y: {
                title: {
                    display: true,
                    text: 'Note',
                },
                min: 1,
                suggestedMax: 6.5,
                ticks: {
                    stepSize: 0.1,
                    family: fontFamily,
                    padding: 5,
                },
                grace: '1%',
            },
        },
    };

    return (
        <div style={{ margin: "10px", height: '60vh', width: '100%' }}> {/* Fix the container size */}
            <Line data={chartData} options={chartOptions} />
        </div>
    );
};

export default GradeChart;
